import {ApplicationAccount} from "../types.ts";
import {
    Stack,
    Text
} from "@mantine/core";
import {formatTimestamp} from "../../../utils/TableTimestamps.tsx";
import {DataTableColumn} from "mantine-datatable";
import {NavLink} from "react-router-dom";


export const useApplicationAccountsTableColumns = (applicationId: string) => {

    if (!applicationId) {
        throw new Error('applicationId is required parameter')
    }

    const columns: DataTableColumn<ApplicationAccount>[] = [
        {
            accessor: 'accountId',
            title: 'Account',
            sortable: true,
            ellipsis: true,
            render: (item) => {
                return (
                    <Stack>
                        {item.account ? <NavLink to={`/accounts/${item.accountId}`}><Text fw={700}
                                                                                          fs={'sm'}>{item.account.username}</Text></NavLink> :
                            <NavLink to={`/accounts/${item.accountId}`}><Text fs={'sm'}
                                                                              fw={700}>{item.accountId}</Text></NavLink>}
                    </Stack>
                )

            },

        },
        {
            accessor: 'accountApplicationStatus',
            title: 'Status',
            sortable: true,
        },
        {
            accessor: 'created',
            title: 'Created',
            sortable: true,
            render: (item) => formatTimestamp(item.created, 'MMM DD, YYYY'),
        }
    ];


    return {
        columns,
    };
};
